import React, { FC, PropsWithChildren, ReactElement } from 'react';
import { CAREMARK_LOB, getLobData, SPECIALTY_LOB } from '../../lib/utils/utils';
import { getDeviceType } from '../../helpers/helpers';
import { Link } from '@digital-pulse/react';
import styles from './lobHeader.module.scss';
import CaremarkLogo from '../../public/images/caremarkLogo.svg';
import SpecialtyLogo from '../../public/images/specialtyLogo.svg';
import CVSLogo from '../../public/images/cvsLogo.svg';

const LobHeader: FC<PropsWithChildren> = (): ReactElement => {
  const lobData = getLobData();

  return (
    <div className={styles.header__container}>
      <div className={styles.logo}>
        <a href="/">
          {lobData?.LOB === CAREMARK_LOB ? (
            <CaremarkLogo role="img" aria-label="Caremark Logo" />
          ) : lobData?.LOB === SPECIALTY_LOB ? (
            <SpecialtyLogo role="img" aria-label="Specialty Logo" />
          ) : (
            <CVSLogo role="img" aria-label="CVS Logo" />
          )}
        </a>
      </div>

      {getDeviceType() === 'DESKTOP' && lobData?.links && lobData?.links?.length > 0 && (
        <div className={'styles.links'}>
          {lobData?.links.map((item) => {
            return (
              <Link href={item.link} isNewTab={true} key={item.name}>
                {' '}
                {item.name}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LobHeader;
